import { FormGroup } from '@UI/index';
import { Modal } from '@kathondvla/react-shared-components/src/components';

import './modals.scss';
import iconDeleteWhite from '@assets/img/delete_white.svg';
import archiveSvg from '@assets/img/archive_white.svg';
import ArchiveIcon from '@mui/icons-material/Archive';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from '@mui/material';

const DeleteCalendarModal = ({ plan, isDelete = false, onConfirm, onClose }) => {
  return (
    <>
      <Modal.Header
        title={`Vorderingsplan(nen) ${isDelete ? 'verwijderen' : 'archiveren'}`}
        subtitle={`Ben je zeker dat je dit/deze vorderingsplannen wil ${isDelete ? 'verwijderen' : 'archiveren'}?`}
        icon={isDelete ? iconDeleteWhite : archiveSvg}
        onClose={onClose}
      />

      <Modal.Body>
        <FormGroup label="Leerplan" subtitle="Welk leerplan dient als basis?">
          <span className="modal-text-name">{plan?.plan}</span>
        </FormGroup>

        <FormGroup label="Klas(sen)" subtitle="Voor welke klassen?">
          <span className="modal-text-name">{plan?.classes}</span>
        </FormGroup>

        <FormGroup label="Leerkrachten" subtitle="Wie kan het bewerken?">
          <span className="modal-text-name">{plan?.teachers}</span>
        </FormGroup>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outlined" onClick={onClose}>
          Annuleren
        </Button>
        <Button
          startIcon={isDelete ? <DeleteIcon /> : <ArchiveIcon />}
          variant="contained"
          onClick={onConfirm}
        >
          {isDelete ? 'Verwijderen' : 'Archiveren'}
        </Button>
      </Modal.Footer>
    </>
  );
};

export default DeleteCalendarModal;
